module.exports = "<sb-progress message=\"vm.loginMessage\" backdrop=\"true\" show=\"true\" />\n";


//////////////////
// WEBPACK FOOTER
// ./src/phoenix/components/login/login-idp-callback.template.html
// module id = 686
// module chunks = 0